module.exports = __webpack_public_path__ + "static/media/azure.ab957f50.svg";